import { useContext, useEffect, useState } from 'react'
import { ModalContext } from '@nv/contexts'
import { CheckAnimationIcon } from '@nv/images/design/check-animation-icon'
import MemberIcon from '@nv/images/design/member-icon'
import { XCircleAnimatedIcon } from '@nv/images/design/x-circle-animated-icon'
import { AdminVoterAuthService } from '@nv/services'
import { useTranslation } from 'react-i18next'
import styles from './ConfirmDeleteAdmin.module.scss'

export const ConfirmDeleteAdmin = ({ selectedUser, fetchUsers }) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)
  const [status, setStatus] = useState('idle')
  const [loading, setLoading] = useState(false)
  const name = selectedUser?.username

  const callConfirm = async () => {
    if (!selectedUser || loading) return
    setLoading(true)

    try {
      const resp = await AdminVoterAuthService.adminDeleteUser(selectedUser.id)
      setStatus(resp.success ? 'success' : 'error')
    } catch {
      setStatus('error')
    }

    setLoading(false)
    fetchUsers()
  }

  useEffect(() => {
    setHeaderLabel(t('admin.adminUsers.confirmDeleteAdmin'))
    setBtns([
      ...(status === 'idle' ? [{ text: t('buttons.cancel'), onClick: onClose, variant: 'secondary', disabled: loading }] : []),
      {
        text: status !== 'idle' ? t('buttons.ok') : t('buttons.delete'),
        onClick: status !== 'idle' ? onClose : callConfirm,
        disabled: loading,
      },
    ])
  }, [status, loading])

  return (
    <div className={styles['container']}>
      {status === 'idle' ? (
        <>
          <MemberIcon />
          <span>{t('admin.adminUsers.confirmDelete', { name: name })}</span>
        </>
      ) : status === 'success' ? (
        <>
          <CheckAnimationIcon />
          <span>{t('admin.adminUsers.successDeleteUser', { name: name })}</span>
        </>
      ) : (
        <>
          <XCircleAnimatedIcon />
          <span>{t('admin.adminUsers.errorDeleteUser', { name: name })}</span>
        </>
      )}
    </div>
  )
}
